module.exports = __webpack_public_path__ + "img/blue_dots.dbf42053.svg";